import { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { CheckCircle2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

export default function PaypalPay({ orderNum, total, onPaid }) {
  const [cfg, setCfg] = useState(null);

  useEffect(() => { api.get("/paypal/config").then(({ data }) => setCfg(data)).catch(() => setCfg({ configured: false })); }, []);

  if (!cfg) return <div className="text-ape-muted text-sm font-mono2">Loading payment…</div>;

  if (!cfg.configured) {
    return (
      <div className="border border-ape-border bg-ape-surface p-5 text-left">
        <div className="font-head uppercase tracking-wide text-sm">Pay with PayPal</div>
        <p className="text-ape-muted text-sm mt-2">PayPal isn't connected yet. Add your PayPal API keys to enable secure online payment. Our team will contact you to finalize payment in the meantime.</p>
      </div>
    );
  }

  return (
    <div className="text-left" data-testid="paypal-section">
      <div className="font-head uppercase tracking-wide text-sm mb-3">Pay ${total.toFixed(2)} with PayPal</div>
      <PayPalScriptProvider options={{ clientId: cfg.client_id, currency: "USD" }}>
        <PayPalButtons
          style={{ layout: "vertical", color: "black", shape: "rect", label: "paypal" }}
          createOrder={async () => {
            const { data } = await api.post("/paypal/create-order", { order_num: orderNum });
            return data.id;
          }}
          onApprove={async (data) => {
            try {
              const { data: res } = await api.post("/paypal/capture-order", { order_num: orderNum, paypal_order_id: data.orderID });
              if (res.status === "COMPLETED") { toast.success("Payment complete!"); onPaid(); }
              else toast.error("Payment not completed.");
            } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
          }}
          onError={() => toast.error("PayPal error. Please try again.")}
        />
      </PayPalScriptProvider>
    </div>
  );
}
